import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "row mb-20" }
const _hoisted_4 = { class: "col-md-6 d-flex align-items-center" }
const _hoisted_5 = { class: "col-md-6 d-flex align-items-center" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 3,
  class: "text-nowrap"
}
const _hoisted_14 = {
  key: 4,
  class: "d-flex align-items-center gap-2 action-buttons"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { key: 5 }
const _hoisted_19 = {
  class: "modal fade",
  id: "modal_details",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_20 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_21 = { class: "modal-content p-4" }
const _hoisted_22 = { class: "modal-header" }
const _hoisted_23 = { class: "modal-title" }
const _hoisted_24 = { class: "modal-body" }
const _hoisted_25 = { class: "row g-4" }
const _hoisted_26 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_27 = ["href"]
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_30 = ["href"]
const _hoisted_31 = ["src"]
const _hoisted_32 = {
  key: 2,
  class: "col-12"
}
const _hoisted_33 = ["href"]
const _hoisted_34 = {
  key: 3,
  class: "col-12 text-center text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }, [
        _createElementVNode("div", { class: "d-sm-flex align-items-center" }),
        _createElementVNode("div", { class: "d-sm-flex align-items-center" })
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[5] || (_cache[5] = _createElementVNode("label", null, "Voir", -1)),
            _createVNode(_component_v_select, {
              modelValue: _ctx.filters.per_page,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.per_page) = $event)),
              options: [10, 25, 50],
              clearable: false,
              class: "per-page-selector d-inline-block mx-50",
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getRecords()))
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", null, "sur " + _toDisplayString(_ctx.filters.total) + " entités", 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control shadow-none text-black rounded-0",
              placeholder: "Chercher",
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter())),
              onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.searchTerm) = $event))
            }, null, 544), [
              [_vModelText, _ctx.filters.searchTerm]
            ])
          ])
        ]),
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns,
          rows: _ctx.rows,
          loading: _ctx.isLoader
        }, {
          emptystate: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("Aucune entrées correspondantes trouvées", -1)
              ])),
              _: 1,
              __: [6]
            })
          ]),
          "table-row": _withCtx((props) => [
            (props.column.field == 'logo')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("img", {
                        src: props.row.logo,
                        class: "rounded-circle me-8",
                        width: "24",
                        height: "24",
                        alt: "user"
                      }, null, 8, _hoisted_9),
                      _createTextVNode(" " + _toDisplayString(props.row.name), 1)
                    ])
                  ])
                ]))
              : (props.column.field === 'info')
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                    _createElementVNode("span", null, [
                      _cache[7] || (_cache[7] = _createElementVNode("b", null, "CIN : ", -1)),
                      _createTextVNode(_toDisplayString(props.row.cin), 1)
                    ]),
                    _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                    _createElementVNode("span", null, [
                      _cache[8] || (_cache[8] = _createElementVNode("b", null, "Téléphone : ", -1)),
                      _createTextVNode(_toDisplayString(props.row.phone), 1)
                    ]),
                    _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
                    _createElementVNode("span", null, [
                      _cache[9] || (_cache[9] = _createElementVNode("b", null, "Email : ", -1)),
                      _createTextVNode(_toDisplayString(props.row.email), 1)
                    ]),
                    _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                    _createElementVNode("span", null, [
                      _cache[10] || (_cache[10] = _createElementVNode("b", null, "Ville : ", -1)),
                      _createTextVNode(_toDisplayString(props.row.city), 1)
                    ]),
                    _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                    _createElementVNode("span", null, [
                      _cache[11] || (_cache[11] = _createElementVNode("b", null, "Adresse : ", -1)),
                      _createTextVNode(_toDisplayString(props.row.address), 1)
                    ]),
                    (props.row.store_name)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(props.row.store_name), 1))
                      : _createCommentVNode("", true)
                  ]))
                : (props.column.field === 'statut')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      innerHTML: _ctx.verificationBadges(props.row)
                    }, null, 8, _hoisted_12))
                  : (props.column.field === 'created_at')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.getDate(props.row.created_at)), 1))
                    : (props.column.field === 'action')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          (_ctx.auth.can('CUSTOMERS'))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn btn-sm btn-outline-primary action-btn",
                                title: "Voir les détails",
                                onClick: ($event: any) => (_ctx.openModal(props.row))
                              }, _cache[16] || (_cache[16] = [
                                _createElementVNode("i", { class: "flaticon-view" }, null, -1)
                              ]), 8, _hoisted_15))
                            : _createCommentVNode("", true),
                          (
                  _ctx.auth.can('CUSTOMERS') &&
                  props.row.cin_verified == 0 &&
                  props.row.ask_cin_verified == 1
                )
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "btn btn-sm btn-outline-success action-btn",
                                title: "Valider le CIN",
                                onClick: ($event: any) => (_ctx.validateCIN(props.row))
                              }, _cache[17] || (_cache[17] = [
                                _createElementVNode("i", { class: "flaticon-check" }, null, -1)
                              ]), 8, _hoisted_16))
                            : _createCommentVNode("", true),
                          (
                  _ctx.auth.can('CUSTOMERS') &&
                  props.row.contrat_verified == 0 &&
                  props.row.ask_cntr_verified == 1
                )
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 2,
                                class: "btn btn-sm btn-outline-success action-btn",
                                title: "Valider le contrat",
                                onClick: ($event: any) => (_ctx.validateCTR(props.row))
                              }, _cache[18] || (_cache[18] = [
                                _createElementVNode("i", { class: "flaticon-check" }, null, -1)
                              ]), 8, _hoisted_17))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows", "loading"]),
        _createVNode(_component_PaginatorContent, {
          pagination: _ctx.filters,
          offset: 9,
          onPaginate: _ctx.getRecords
        }, null, 8, ["pagination", "onPaginate"])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("h5", _hoisted_23, "Vérification – " + _toDisplayString(_ctx.docs?.customer?.name), 1),
            _cache[20] || (_cache[20] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              (_ctx.docs?.customer?.cin_recto)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _cache[21] || (_cache[21] = _createElementVNode("p", { class: "fw-bold mb-2" }, "CIN Recto", -1)),
                    (_ctx.isPdf(_ctx.docs.customer.cin_recto))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: _ctx.docs.customer.cin_recto,
                          target: "_blank",
                          class: "btn btn-outline-primary"
                        }, " Ouvrir PDF ", 8, _hoisted_27))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: _ctx.docs.customer.cin_recto,
                          class: "img-fluid rounded shadow"
                        }, null, 8, _hoisted_28))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.docs?.customer?.cin_verso)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _cache[22] || (_cache[22] = _createElementVNode("p", { class: "fw-bold mb-2" }, "CIN Verso", -1)),
                    (_ctx.isPdf(_ctx.docs.customer.cin_verso))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: _ctx.docs.customer.cin_verso,
                          target: "_blank",
                          class: "btn btn-outline-primary"
                        }, " Ouvrir PDF ", 8, _hoisted_30))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: _ctx.docs.customer.cin_verso,
                          class: "img-fluid rounded shadow"
                        }, null, 8, _hoisted_31))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.docs?.customer?.contrat_file)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _cache[23] || (_cache[23] = _createElementVNode("p", { class: "fw-bold mb-2" }, "Contrat", -1)),
                    _createElementVNode("a", {
                      href: _ctx.docs.customer.contrat_file,
                      target: "_blank",
                      class: "btn btn-outline-primary"
                    }, " Ouvrir le contrat ", 8, _hoisted_33)
                  ]))
                : _createCommentVNode("", true),
              (
                !_ctx.docs?.customer?.cin_recto &&
                !_ctx.docs?.customer?.cin_verso &&
                !_ctx.docs?.customer?.contrat_file
              )
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, " Aucun document disponible "))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}